import DatePicker from 'antd/lib/date-picker';
import 'antd/lib/date-picker/style/css';

const {MonthPicker} = DatePicker;

export default MonthPicker;
